"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _materialTable = _interopRequireWildcard(require("material-table"));

var _reactI18next = require("react-i18next");

require("./Datagrid.css");

var _sorting = _interopRequireDefault(require("./sorting"));

var _pagination = _interopRequireDefault(require("./pagination"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MatDatagrid = /*#__PURE__*/function (_React$Component) {
  _inherits(MatDatagrid, _React$Component);

  var _super = _createSuper(MatDatagrid);

  function MatDatagrid() {
    _classCallCheck(this, MatDatagrid);

    return _super.apply(this, arguments);
  }

  _createClass(MatDatagrid, [{
    key: "render",
    value: function render() {
      var _this = this,
          _extends2;

      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "main-div"
      }, /*#__PURE__*/_react.default.createElement(_materialTable.default //stickyHeader 
      , _extends({}, this.props, (_extends2 = {
        components: this.props.customPagination && this.props.customPagination.isDisplay && {
          Pagination: function Pagination(props) {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "custum-table"
            }, /*#__PURE__*/_react.default.createElement(_pagination.default, _extends({}, props, {
              classes: {
                root: ""
              },
              totalButton: _this.props.customPagination
            })));
          }
        }
      }, _defineProperty(_extends2, "components", this.props.isCustomHeader ? {
        Header: function Header(props) {
          return /*#__PURE__*/_react.default.createElement(_sorting.default //stickyHeader
          , _extends({}, props, {
            orderDirection: _this.props.orderDirection,
            thirdSortClick: false,
            onOrderChange: _this.props.onOrderChange,
            onColumnDragged: _this.props.onColumnDragged,
            orderBy: _this.props.orderBy,
            actionColumnStyle: _this.props.actionColumnStyle
          }));
        }
      } : ""), _defineProperty(_extends2, "title", t(this.props.title)), _defineProperty(_extends2, "data", this.props.rows), _defineProperty(_extends2, "columns", this.props.columns), _defineProperty(_extends2, "onSelectionChange", this.props.onSelectionChange), _defineProperty(_extends2, "options", {
        grouping: this.props.grouping,
        selection: this.props.selection,
        filtering: this.props.filtering,
        exportButton: this.props.exportButton,
        exportAllData: this.props.exportAllData,
        exportCsv: this.props.exportCsv,
        exportPdf: this.props.exportPdf,
        pageSize: this.props.pageSize ? this.props.pageSize : 5,
        pageSizeOptions: this.props.pageSizeOptions,
        addRowPosition: this.props.addRowPosition,
        actionsColumnIndex: this.props.actionsColumnIndex ? this.props.actionsColumnIndex : '',
        search: this.props.search,
        paginationType: this.props.paginationType,
        showFirstLastPageButtons: this.props.showFirstLastPageButtons,
        paging: this.props.paging,
        padding: "small",
        thirdSortClick: false,
        sorting: this.props.isCustomHeader ? false : this.props.sorting,
        headerStyle: this.props.stickyHeader && this.props.stickyHeader.show ? {
          position: 'sticky',
          top: 0
        } : '',
        maxBodyHeight: this.props.stickyHeader && this.props.stickyHeader.show ? this.props.stickyHeader.maxBodyHeight : '',
        fixedColumns: this.props.fixColumns && this.props.fixColumns.show ? this.props.fixColumns.fixedColumns : '',
        rowStyle: this.props.rowStyle,
        onRowClick: this.props.onRowClick
      }), _defineProperty(_extends2, "parentChildData", this.props.treeView ? function (row, rows) {
        return rows.find(function (a) {
          return a.id === row.parentId;
        });
      } : null), _defineProperty(_extends2, "editable", this.props.editable && this.props.editable.editable ? {
        onRowAdd: this.props.editable.showAdd ? function (newData) {
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              _this.props.addRow(newData);

              resolve();
            }, 1000);
          });
        } : "",
        onRowUpdate: this.props.editable.showEdit ? function (newData, oldData) {
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              {
                console.log("sf", newData, oldData);

                _this.props.rowUpdate(newData, oldData);
              }
              resolve();
            }, 1000);
          });
        } : "",
        onRowDelete: this.props.editable.showDelete ? function (oldData) {
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              {
                _this.props.rowDelete(oldData);
              }
              resolve();
            }, 1000);
          });
        } : ""
      } : false), _defineProperty(_extends2, "icons", this.props.customIcon), _defineProperty(_extends2, "onFilterChange", this.props.onFilterChange), _defineProperty(_extends2, "onChangePage", this.props.onChangePage), _defineProperty(_extends2, "onChangeRowsPerPage", this.props.onChangeRowsPerPage), _defineProperty(_extends2, "onOrderChange", this.props.onOrderChange), _defineProperty(_extends2, "onFilterChange", this.props.onFilterChange), _defineProperty(_extends2, "onSearchChange", this.props.onSearchChange), _defineProperty(_extends2, "onTreeExpandChange", this.props.onTreeExpandChange), _defineProperty(_extends2, "actions", this.props.actionsColumn), _defineProperty(_extends2, "onBulkEditRowChanged", function onBulkEditRowChanged(e) {
        return console.log("Zsdgsg");
      }), _extends2))));
    }
  }]);

  return MatDatagrid;
}(_react.default.Component);

var _default = (0, _reactI18next.withTranslation)()(MatDatagrid);

exports.default = _default;